import { render } from "./AlzataSplash.vue?vue&type=template&id=2a8b458b"
import script from "./AlzataSplash.vue?vue&type=script&lang=js"
export * from "./AlzataSplash.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__